import Loader from "../../DomUtilities/Loader";
import openErrorModal from "../../Error/ErrorModal";
import { fetchCustomerQuestionsModal, fetchFirstCustomerQuestionsModal } from "../../HTTPRequests/OrderRequests";

export default class CustomerQuestionsModal {
	modalDiv: HTMLDivElement;
	id: string;
	private readonly iconFirstQuestionnaireSelector: string = ".icon-list-alt";
	private readonly iconQuestionnaireSelector: string = ".icon-file-text-alt";

	constructor(id: string) {
		this.modalDiv = document.createElement("div");
		this.id = id;
	}

	public init(parentSelector: HTMLElement, isFirstQuestionnaire: boolean) {
		if (isFirstQuestionnaire) {
			this.FirstQuestionnaireModalFetcher(parentSelector);
		}
		else {
			this.QuestionnaireModalFetcher(parentSelector);
		}
	}

	private FirstQuestionnaireModalFetcher(parentSelector: HTMLElement) {
		const icon: HTMLElement = parentSelector.querySelector(this.iconFirstQuestionnaireSelector);

		if (icon) {
			icon.onclick = (event) => {
				event.stopPropagation();
				this.fetchFirstQuestionnaireModal();
			}
		}
	}

	private QuestionnaireModalFetcher(parentSelector: HTMLElement) {
		var icon: HTMLElement = parentSelector.querySelector(this.iconQuestionnaireSelector); 

		if (icon) {
			icon.onclick = (event) => {
				event.stopPropagation();
				this.fetchModal();
			}
		}
	}

	private fetchFirstQuestionnaireModal() {
		Loader.show();
		fetchFirstCustomerQuestionsModal(this.id)
			.then((response: string) => {
				this.openModal(response);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				Loader.hide();
			});
	}

	private fetchModal() {
		Loader.show();
		fetchCustomerQuestionsModal(this.id)
			.then((response: string) => {
				this.openModal(response);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				Loader.hide();
			});
	}

	private openModal(modalHTMLString: string) {
		this.modalDiv.innerHTML = modalHTMLString;
		document.body.appendChild(this.modalDiv);
		this.addModalClickListeners();
	}

	private addModalClickListeners() {
		const closeImg: HTMLImageElement = this.modalDiv.querySelector('img[alt="close icon"]');
		closeImg.onclick = () => {
			this.modalDiv.remove();
		}

		this.modalDiv.onclick = (event) => {
			if (event.target === this.modalDiv.firstElementChild) {
				this.modalDiv.remove();
			}
		}
	}
}
